module.exports = __webpack_public_path__ + "assets/rp-rain-delay-time-2e818251.png";